module.exports = __webpack_public_path__ + "media/images/stat-total-reviews-dark-a21b056d.svg";